import { useState } from 'react'
import { useAsync } from 'react-use'

import { Applications } from 'types/Application'
import fetchApplications from 'utils/fetchApplications'

const useApplications = (): Applications => {
  const [applications, setApplications] = useState<Applications>({ items: [] })

  useAsync(async () => {
    const applications = await fetchApplications()
    if (applications) {
      setApplications(applications)
    } else {
      setApplications({
        items: [],
      })
    }
  }, [])

  return applications
}

export default useApplications
